import React from 'react';
import PropertySearch from './PropertySearch';
import FleetChatAssistant from './FleetChatAssistant';

// Keep this site's established filters and MLS/private search separate from the shared conversation UI.
export default function ActionButtons(props) {
  if (props.isGlobeMap || props.isMapPage) return <PropertySearch {...props} />;
  return <FleetChatAssistant {...props} />;
}
